import { mdiAccountCircle } from "@mdi/js";
import { useAuth } from "react-oidc-context";
import { useTranslation } from "react-i18next";
import { ViewerHelpDropdownMenuItem } from "./ViewerHelpDropdownMenuItem";
import { ViewerLoginDropdownMenuItem } from "./ViewerLoginDropdownMenuItem";
import { ViewerLogoutDropdownMenuItem } from "./ViewerLogoutDropdownMenuItem";
import { ViewerSettingsDropdownMenuItem } from "./ViewerSettingsDropdownMenuItem";
import { NavbarButtonIcon } from "./NavbarButtonIcon";
import { NavbarButton } from "./NavbarButton";
import { ViewerImprintDropdownMenuItem } from "./ViewerImprintDropdownMenuItem";
import { ViewerPrivacyDropdownMenuItem } from "./ViewerPrivacyDropdownMenuItem";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@acdc2/ui/components/dropdown-menu";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@acdc2/ui/components/avatar";

export function ViewerAccountNavbarButton() {
  const { t } = useTranslation();
  const auth = useAuth();
  const username = auth.user?.profile?.preferred_username;

  return (
    <DropdownMenu>
      <NavbarButton tooltip={t("ViewerAccountNavbarButton.tooltip")}>
        <DropdownMenuTrigger asChild>
          {auth.user ? (
            <Avatar className="rounded-lg size-8 m-0.5 cursor-pointer">
              <AvatarImage src={auth.user.profile.picture} />
              <AvatarFallback className="rounded-lg">
                {username?.charAt(0).toUpperCase()}
              </AvatarFallback>
            </Avatar>
          ) : (
            <NavbarButtonIcon path={mdiAccountCircle} />
          )}
        </DropdownMenuTrigger>
      </NavbarButton>
      <DropdownMenuContent className="my-2" side="right">
        {username ? (
          <>
            <DropdownMenuLabel>
              {t("ViewerAccountNavbarButton.label", { name: username })}
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <ViewerHelpDropdownMenuItem />
            <ViewerImprintDropdownMenuItem />
            <ViewerPrivacyDropdownMenuItem />
            <DropdownMenuSeparator />
            <ViewerSettingsDropdownMenuItem />
            <ViewerLogoutDropdownMenuItem />
          </>
        ) : (
          <>
            <ViewerHelpDropdownMenuItem />
            <ViewerImprintDropdownMenuItem />
            <ViewerPrivacyDropdownMenuItem />
            <ViewerLoginDropdownMenuItem />
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
